// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
export const getOrders = state => state.ordersReducer.orders;
export const getLoading = state => state.ordersReducer.loading;
export const getError = state => state.ordersReducer.error;
